module.exports = __webpack_public_path__ + "static/media/emprendada.f7a4a713.svg";